import React, { useState } from "react";
import { useSelector } from "react-redux"
import { useLocation, Link } from "react-router-dom";
import { Navigation, TextContainer } from "./styles";
//Interfaces
import { NavTabsPropsInterface } from "./interfaces";
import color from "../../assets/css/colors";

const NavTabs = ({
    tabs
}: NavTabsPropsInterface
): React.ReactElement => {
    const [hover, setHover] = useState<String>("");

    const login = useSelector((state: {login: any}) => state.login);

    const location = useLocation();
    const locationArray = location.pathname.split("/");
    const pathChildren = `/${locationArray[3]}`;

    const navItemGenerator = () => {
        const imageDefiner = (path: String, name: String) => {
            if(pathChildren === path){
                return true;
            } else {
                if(hover === name){
                    return true;
                } else{
                    return false
                }
            }
        }

        return tabs.map((tab, index) => {
            tab.id = tab.id !== undefined ? tab.id : "";
            
            if(login.user.branchsId === null){
                return(
                    <li className="nav-item" key={index}>
                        <Link 
                            className={`nav-link ${ pathChildren === tab.path ? "active" : "" } d-flex align-items-center`}
                            onMouseEnter={() => setHover(tab.name)}
                            onMouseLeave={() => setHover("")}
                            to={`/admin${tab.layout}${tab.path}`}
                        >
                            <img src={imageDefiner(tab.path, tab.name) ? tab.iconHover : tab.icon} className="logo-img"/>
                            <TextContainer>
                                <span style={{marginLeft: 11}}>{tab.name}</span>
                            </TextContainer>
                        </Link>
                    </li>

                )
            } else if(login.user.groups[tab.id]){
            return(
                    <li className="nav-item" key={index}>
                        <Link 
                            className={`nav-link ${ pathChildren === tab.path ? "active" : "" } d-flex align-items-center`}
                            onMouseEnter={() => setHover(tab.name)}
                            onMouseLeave={() => setHover("")}
                            to={`/admin${tab.layout}${tab.path}`}
                            style={{outlineColor: `${color.primary}`}}
                        >
                            <img src={imageDefiner(tab.path, tab.name) ? tab.iconHover : tab.icon} className="logo-img"/>
                            <TextContainer>
                                <div style={{marginLeft: 11, width: "max-content"}}>{tab.name}</div>
                            </TextContainer>
                        </Link>
                    </li>

                )
            } 
        })
    }

    return(
        <Navigation className="nav nav-tabs" style={{marginTop: 48, marginBottom: 49}}>
            {navItemGenerator()}
        </Navigation>
    )

}

export default NavTabs;